import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PropertyConditionService } from '../property-condition.service';
import { PropertyCondition } from '../property-condition';
import { PropertyConditionComponent } from '../property-condition/property-condition.component';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-property-condition-list',
    templateUrl: './property-condition-list.component.html',
    styleUrls: ['./property-condition-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PropertyConditionListComponent implements OnInit {
    categories: any;
    urgencies: any;
    rooms: any;
    reasons: any;
    outcomes: any;
    visibilities: any;
	properties: any[]=[];
	constructor(
		private propertyConditionService: PropertyConditionService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private propertyService: PropertyService,
		private dialog: MatDialog,
	) {
		this.fetchProperties();
		this.statuses = propertyConditionService.statuses;
		this.categories = propertyConditionService.categories;
		this.urgencies = propertyConditionService.urgencies;
		this.rooms = propertyConditionService.rooms;
		this.reasons = propertyConditionService.reasons;
		this.outcomes = propertyConditionService.outcomes;
		this.visibilities = propertyConditionService.visibilities;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() shortTermRentalId: any;
	propertyConditions: any;
	propertyCondition: PropertyCondition;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'createDate', header: 'Date', width: 'auto' },
		{ field: 'shortTermRentalVO.shortTermRentalId', header: 'Property Code', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'urgency', header: 'Urgency', width: 'auto' },
		{ field: 'room', header: 'Room', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'reason', header: 'Reason', width: 'auto' },
		{ field: 'outcome', header: 'Outcome', width: 'auto' },
		{ field: 'costEst', header: 'Cost Est', width: 'auto' },
		/*{ field: 'enteredByUserId', header: 'Entered By', width: 'auto' },*/
		{ field: 'visibility', header: 'Visibility', width: 'auto' },
		{ field: 'opsNotes', header: 'Ops Notes', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.propertyConditionId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-propertyCondition-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.shortTermRentalId)
				{
					// show only shortTermRentals that are assigned to this propertyCodeFilter
					let propertyIdFilter = { 'shortTermRentalVO.shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
					Object.assign(event.filters, propertyIdFilter);
				}

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyConditionService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.propertyConditions = res.data.propertyConditions;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.propertyConditions = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(propertyCondition: PropertyCondition) {
		try {
			this.formLoading = true;
			this.propertyConditionService.update(propertyCondition)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.propertyConditions.map((propertyCondition, i) => {
							if (propertyCondition.propertyConditionId === res.data.propertyCondition.propertyConditionId) {
								this.propertyConditions[i] = res.data.propertyCondition;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(propertyCondition: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(propertyCondition));

			this.formLoading = true;
			this.propertyConditionService.delete(propertyCondition.propertyConditionId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.propertyConditions.splice(this.propertyConditions.indexOf(propertyCondition), 1);
						this.recordTotal = this.propertyConditions.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PropertyCondition ' + propertyCondition.propertyConditionId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PropertyCondition ' + propertyCondition.propertyConditionId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
			dialogConfig.width = "25vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Property Condition'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyConditionComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyConditionCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(propertyCondition: PropertyCondition) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
			dialogConfig.width = "25vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyCondition: propertyCondition,
			title: 'Edit Property Condition'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyConditionComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePropertyConditionCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePropertyConditionCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyConditionCB(propertyCondition: PropertyCondition) {
		console.log('Adding PropertyCondition: ' + JSON.stringify(propertyCondition));
		// if we don't have a propertyConditions array yet...
		if (!this.propertyConditions) {
			this.propertyConditions = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.propertyConditions.unshift(propertyCondition);

		// no idea what this is but it is required to update the array
		this.propertyConditions = [...this.propertyConditions];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyCondition ' + propertyCondition.propertyConditionId + ' Added', life: 3000 });
	}

	updatePropertyConditionCB(propertyCondition: PropertyCondition) {
		console.log('Updating PropertyCondition: ' + JSON.stringify(propertyCondition));
		let itemIndex = this.propertyConditions.findIndex((item: any) => item.propertyConditionId === propertyCondition.propertyConditionId);
		this.propertyConditions[itemIndex] = propertyCondition;

		// no idea what this is but it is required to update the array
		this.propertyConditions = [...this.propertyConditions];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyCondition ' + propertyCondition.propertyConditionId + ' Updated', life: 3000 });
	}

	deletePropertyConditionCB(propertyCondition: PropertyCondition) {
		console.log('Removing PropertyCondition: ' + propertyCondition);
		this.propertyConditions.splice(this.propertyConditions.indexOf(propertyCondition), 1);
		this.recordTotal = this.propertyConditions.length;

		// no idea what this is but it is required to update the array
		this.propertyConditions = [...this.propertyConditions];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyCondition ' + propertyCondition.propertyConditionId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.propertyConditions ? this.first === (this.propertyConditions.length - this.rows) : true; }
	isFirstPage(): boolean { return this.propertyConditions ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(propertyCondition: any) {
		if (propertyCondition?.status) {
			const status = this.statuses.find((e: any) => e.value == propertyCondition.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getCategoryName(propertyCondition: any) {
		if (propertyCondition?.category) {
			const status = this.categories.find((e: any) => e.value == propertyCondition.category);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getUrgencyName(propertyCondition: any) {
		if (propertyCondition?.urgency) {
			const status = this.urgencies.find((e: any) => e.value == propertyCondition.urgency);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getRoomName(propertyCondition: any) {
		if (propertyCondition?.room) {
			const status = this.rooms.find((e: any) => e.value == propertyCondition.room);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getReasonName(propertyCondition: any) {
		if (propertyCondition?.reason) {
			const status = this.reasons.find((e: any) => e.value == propertyCondition.reason);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getOutcomeName(propertyCondition: any) {
		if (propertyCondition?.outcome) {
			const status = this.outcomes.find((e: any) => e.value == propertyCondition.outcome);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getvisibilityName(propertyCondition: any) {
		if (propertyCondition?.visibility) {
			const status = this.visibilities.find((e: any) => e.value == propertyCondition.visibility);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getPropertyCode(shortTermRentalId: any) {
		if (shortTermRentalId) {
			const status = this.properties.find((e: any) => e.shortTermRentalId == shortTermRentalId);
			return status.propertyCode;
		}
		else {
			return '';
		}
	}
}
